import mascotIntro from '@echo/brand/assets/mascot-intro-timer.png';
import { EXERCISE_COPY, exerciseKindSchema, nextStep } from '@echo/core';
import { Button, SpeechBubble } from '@echo/ui-web';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ContentFrame, ExercisePage } from '@/components/exercise-frame';
import { InfoIcon } from '@/components/info-icon';
import { useExerciseChoice } from '@/lib/exercise-routes';

export const Route = createFileRoute('/_app/exercise/$kind/intro')({
  params: {
    parse: ({ kind }) => ({ kind: exerciseKindSchema.parse(kind) }),
    stringify: ({ kind }) => ({ kind }),
  },
  component: ExerciseIntroPage,
});

/** Coach screen before each exercise. */
function ExerciseIntroPage() {
  const { kind } = Route.useParams();
  const choice = useExerciseChoice();
  const { t } = useLingui();
  const navigate = useNavigate();
  const copy = EXERCISE_COPY[kind];
  // What the chooser picked (reading and writing choose first) travels through to the exercise.
  const start = () => {
    if (nextStep(kind, 'intro') === 'choose') {
      void navigate({ to: '/exercise/$kind/choose', params: { kind } });
    } else {
      void navigate({ to: '/exercise/$kind', params: { kind }, state: { exercise: choice } });
    }
  };

  return (
    <ExercisePage>
      <ContentFrame
        footer={
          <>
            <Button variant="ghost" onClick={() => navigate({ to: '/' })}>
              {t`Back to home`}
            </Button>
            <Button onClick={start}>{t`Start exercise`}</Button>
          </>
        }
      >
        <SpeechBubble level="body-lg" className="px-content-md">
          {t(copy.intro.body)}
        </SpeechBubble>
        {/* One illustration for the three intros: Brian and a plain stopwatch, whatever the duration. */}
        <img
          src={mascotIntro}
          alt={t`A cheerful brain character getting ready`}
          className="h-auto w-[375px] max-w-full object-contain"
        />
        <p className="flex w-full items-start gap-internal-md py-internal-lg text-body-md text-on-surface-medium">
          <InfoIcon />
          <span className="flex-1">{t(copy.intro.hint)}</span>
        </p>
      </ContentFrame>
    </ExercisePage>
  );
}
